export function toFilteringUrl(url: string, filter: any): string {
  if (typeof filter === 'object' && Object.keys(filter)?.length) {
    const searchParams = new URLSearchParams(filter).toString();
    return url.concat('?', searchParams);
  }
  else if (typeof filter === 'string' && filter) {
    return url.concat('?', filter);
  }
  return url;
}
